"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DampeningCurseAbilityHandler = exports.DampeningCurseActorAbilityFactory = exports.DampeningCurseAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
class DampeningCurseAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DampeningCurse;
        this.__typeName = "DampeningCurse";
    }
}
exports.DampeningCurseAbilityArgs = DampeningCurseAbilityArgs;
DampeningCurseAbilityArgs.CustomText = "Reduced critical multiplier.";
let DampeningCurseActorAbilityFactory = class DampeningCurseActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DampeningCurse", "Self", 0);
    }
};
DampeningCurseActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DampeningCurse")
], DampeningCurseActorAbilityFactory);
exports.DampeningCurseActorAbilityFactory = DampeningCurseActorAbilityFactory;
let DampeningCurseAbilityHandler = class DampeningCurseAbilityHandler {
    init(sequence, container, actorId) {
        sequence = sequence.pushSequence("parallel");
        const targetIds = container.selectLivingTargets(actorId, Target_1.Target.AllEnemies);
        targetIds.forEach(targetId => container.applyDebuff({
            sequence,
            attackerId: actorId,
            targetId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.LinkedEffectsEffectArgs([
                new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.CriticalDamageMultiplier, 20),
                new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.PercentHealingReceivedDecrease, 20)
            ], true),
            supernatural: true
        }));
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
DampeningCurseAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DampeningCurse)
], DampeningCurseAbilityHandler);
exports.DampeningCurseAbilityHandler = DampeningCurseAbilityHandler;
